import { Upload } from "../models/upload";
import * as AzureStorage from "azure-storage";
import { Observable } from "rxjs";

export const fetchJson = (
  url: string,
  body: any,
  method: string = "POST",
  init?: RequestInit
) => {
  return fetch(url, {
    method: method,
    headers: {
      RequestVerificationToken: window.antiForgeryToken,
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    },
    credentials: "same-origin",
    body: JSON.stringify(body),
    ...init
  });
};

export const loadResourceUploads = (resourceId: number) => {
  return fetch(`/resources/${resourceId}/uploads`, {
    method: "GET",
    headers: {
      RequestVerificationToken: window.antiForgeryToken,
      Accept: "application/json"
    },
    credentials: "same-origin"
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error("Invalid response");
    }
  });
};

export const uploadFile = (file: File, resourceId?: number) => {
  return new Observable<Upload>(subscriber => {
    fetchJson(window.urls.upload.begin, {
      filename: file.name,
      size: file.size,
      type: file.type,
      resourceId
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else if (response.status === 413) {
          subscriber.error("The file was too large");
        } else {
          subscriber.error("An unknown error occured");
        }
      })
      .then(blobOptions => {
        var upload: Upload = {
          id: blobOptions.upload,
          filename: file.name,
          size: file.size,
          uploadProgress: 0,
          uploadComplete: false,
          href: blobOptions.href
        };

        subscriber.next(upload);

        // Upload file to Azure blob storage
        var blobService = AzureStorage.createBlobServiceWithSas(
          blobOptions.serviceUrl,
          blobOptions.sas
        ).withFilter(new AzureStorage.ExponentialRetryPolicyFilter());

        var blockSize =
          file.size > 1024 * 1024 * 32 ? 1024 * 1024 * 4 : 1024 * 512;

        var options = {
          blockSize: blockSize
        };
        blobService.singleBlobPutThresholdInBytes = blockSize;

        var speedSummary = blobService.createBlockBlobFromBrowserFile(
          blobOptions.container,
          blobOptions.blob,
          file,
          options,
          (error, result, response) => {
            console.log(error, result, response);
            if (error) {
              // uploadFailed(error);
              subscriber.error(error);
            } else {
              // Notify the server that the upload is complete
              fetchJson(window.urls.upload.complete, {
                upload: blobOptions.upload
              }).then(response => {
                if (response.ok) {
                  subscriber.next({
                    ...upload,
                    uploadComplete: true,
                    uploadProgress: 100
                  });
                  subscriber.complete();
                } else {
                  console.log(response.body);
                  // uploadFailed("the upload was interrupted");
                }
              });
            }
          }
        );

        speedSummary.on("progress", () => {
          var progress = Number(speedSummary.getCompletePercent(2));
          console.log(progress);
          subscriber.next({
            ...upload,
            uploadComplete: false,
            uploadProgress: progress
          });
        });
      });
  });
};

export const deleteResourceUpload = (resourceId: number, uploadId: number) => {
  return fetchJson(
    `/resources/${resourceId}/download/${uploadId}/delete`,
    undefined,
    "POST"
  ).then(response => {
    if (response.ok) {
      return true;
    } else {
      throw new Error(response.statusText);
    }
  });
};
